<template>
  <v-container text-xs-center>
    <transition name="fade" mode="out-in">
      <v-flex mb-4 class="hidden-sm-and-down" v-if="!welcomeVisible">
        <v-img src="/api/config/Client/getLogo?clientId=0" contain height="50"></v-img>
      </v-flex>
    </transition>
    <transition name="bounce" mode="out-in">
      <v-container v-if="!welcomeVisible" key="2"> <home-dashboard></home-dashboard> </v-container>
    </transition>
  </v-container>
</template>

<script>
import HomeDashboard from '../components/HomeDashboard'

export default {
  mounted() {
    setTimeout(() => (this.welcomeVisible = false), 500)
  },
  data() {
    return {
      welcomeVisible: true,
    }
  },
  components: {
    HomeDashboard,
  },
}
</script>
